import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";
import List from "../../components/List";
import { useModal } from "../../context/ModalContext";
import EditCategories from "./Edit";
import CategoryCard from "./CategoryCard";
import { createCategory, deleteCategory, getCategory, importCategoryExcelData, searchCategories, updateCategory } from "../../api/Category";
import { getAllDrinks } from "../../api/Drink";
import SelectField from "../../components/SelectField";


export default function Categories({ navigate, location }) {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();
  const [drinkOptions, setDrinkOptions] = useState([]);
  const [selectedDrinkId, setSelectedDrinkId] = useState(!!location?.state?.drinkId ? location.state.drinkId : "");

  useEffect(() => {
    const load = async () => {
      const res = await getAllDrinks("nameBr", "ASC");
      setDrinkOptions(res.map(r => ({ label: r.nameBr, value: r.id })));
    }

    load();
  }, []);

  const load = useCallback(() => {
    const search = async () => setData(await searchCategories(query, all, page, undefined, undefined, selectedDrinkId));
    search();
  }, [query, all, page, selectedDrinkId]);

  useEffect(() => {
    load();
  }, [query, all, page, load]);

  const importExcel = async (data) => {
    try {
      await  importCategoryExcelData(data);
      load();
      showModal("Categorias importadas com sucesso!", "success", 10);
    } catch (e) {
      console.log(e.message ?? e);
      showModal("Falha ao importar categorias", "error", 10);
    }
  }

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              nameBr: "",
              order: 0,
              descriptionBr: "",
              drink: null,
              attributes: [],
            })
          }
          Item={(item) => (
            <CategoryCard
              key={"ku" + item.id}
              category={item}
              onEdit={async () => {
                const loaded = await getCategory(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteCategory(item);
                  load();
                } catch (e) {
                  showModal("A categoria não pode ser apagada", "warn", 10);
                }
              }}
              onFilter={() => navigate(
                "/attributes", 
                { state: { drinkId: item.drink.id, categoryId: item.id } }
              )}
            />
          )}
          renderBeforeContent={
            <div className="mt-[-20px] mb-6">
              <SelectField
                label="Bebida"
                className="w-[200px]"
                value={selectedDrinkId} 
                options={drinkOptions} 
                update={(v) => setSelectedDrinkId(v)} 
              />
            </div>
          }
          onReadExcelInput={importExcel}
          excelExampleHeaders={["nameBr", "order", "descriptionBr", "drinkId"]}
        />
      </Content>
      <EditCategories
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (style) => {
          try {
            if (!!style.id) {
              await updateCategory(style);
            } else {
              await createCategory(style);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar categoria", "error", 10);
          }
        }}
      />
    </>
  );
}
